// import React from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
// import ResourceOptions from '../pages/UnAuth/ResourceOptions'
// import ResourceListing from '../pages/UnAuth/ResourceListing'
import ResourceDetails from '../pages/shared/Desktop/ResourceDetails'
import ResourceDetailsMobile from '../pages/shared/Mobile/ResourceDetails'

import Privacy from '../pages/shared/Privacy'
import Terms from '../pages/shared/Terms'
import Disclaimer from '../pages/shared/Disclaimer'
import Eula from '../pages/shared/Eula'
import FinishSignIn from '../pages/shared/FinishSignIn';
import PartnerCommunities from '../pages/shared/Desktop/PartnerCommunities';
import PartnerCommunitiesMobile from '../pages/shared/Mobile/PartnerCommunities';
import PartnerResources from '../pages/shared/Desktop/PartnerResources';
import PartnerResourcesMobile from '../pages/shared/Mobile/PartnerResources';

import { SearchFilterOptionType } from "../data/types";
import FocusGroup from '../pages/UnAuth/FocusGroup'
import FocusGroupAccess from '../pages/UnAuth/FocusGroupAccess'
import FocusGroupSession from '../pages/Auth/FocusGroupSession'
// import Navbar from '../components/Navbar'


type UnAuthViewProps = {
  searchFilterOptions: SearchFilterOptionType
}

const UnAuthView: React.FC<UnAuthViewProps> = ({searchFilterOptions}) => {
  return (
    <Routes>
        <Route path="/focus-group" element={<FocusGroup />}  />
        <Route path="/focus-group/register" element={<FocusGroup />}  />
        <Route path="/focus-group/:sessionId" element={<FocusGroupAccess searchFilterOptions={searchFilterOptions} />}  />
        <Route path="/focus-group/:sessionId/session" element={<FocusGroupSession />}  />
        {/* <Route path="/kitchen" element={<ResourceListing resourceType="kitchen" searchFilterOptions={searchFilterOptions}  />}  />
        <Route path="/documentation" element={<ResourceListing resourceType="documentation" searchFilterOptions={searchFilterOptions}  />}  />
        <Route path="/training" element={<ResourceListing resourceType="training" searchFilterOptions={searchFilterOptions} />}  />
        <Route path="/funding" element={<ResourceListing resourceType="funding" searchFilterOptions={searchFilterOptions}  />}  />
        <Route path="/expert" element={<ResourceListing resourceType="expert" searchFilterOptions={searchFilterOptions}  />}  />
        <Route path="/farm" element={<ResourceListing resourceType="farm" searchFilterOptions={searchFilterOptions}  />}  /> */}
        <Route path="/:resourceType/:resourceId" element={<ResourceDetails searchFilterOptions={searchFilterOptions}  />}  />
        <Route path="/profile" element={<Navigate to="/" replace />} />
        <Route path="/profile/memberships" element={<Navigate to="/" replace />} />
        <Route path="/profile/subscriptions" element={<Navigate to="/" replace />} />
        <Route path="/privacy" element={<Privacy />}  />
        <Route path="/terms" element={<Terms />}  />
        <Route path="/disclaimer" element={<Disclaimer />}  />
        <Route path="/eula" element={<Eula />}  />
        <Route path="/finishSignIn" element={<FinishSignIn />} />
        <Route path="/finishSignIn/:login_token" element={<FinishSignIn />} />
        <Route path="/:resourceType" element={<PartnerResources resourceType={searchFilterOptions.currentFilter.resourceType} searchFilterOptions={searchFilterOptions} />}  />
        {/* <Route path="/all" element={<PartnerResources resourceType="kitchen" searchFilterOptions={searchFilterOptions} />}  /> */}
        <Route path="/communities" element={<PartnerCommunities />}  />
        <Route path="*" element={<PartnerResources resourceType="kitchen" searchFilterOptions={searchFilterOptions} />}  />
        {/* <Route path="*" element={<ResourceOptions  />}  /> */}
    </Routes>
  )
}


export const MobileUnAuthView: React.FC<UnAuthViewProps> = ({searchFilterOptions}) => {
  return (
    <Routes>
        <Route path="/focus-group" element={<FocusGroup />}  />
        <Route path="/focus-group/register" element={<FocusGroup />}  />
        <Route path="/focus-group/:sessionId" element={<FocusGroupAccess searchFilterOptions={searchFilterOptions} />}  />
        <Route path="/focus-group/:sessionId/session" element={<FocusGroupSession />}  />
        <Route path="/:resourceType/:resourceId" element={<ResourceDetailsMobile searchFilterOptions={searchFilterOptions}  />}  />
        <Route path="/profile" element={<Navigate to="/" replace />} />
        <Route path="/profile/memberships" element={<Navigate to="/" replace />} />
        <Route path="/profile/subscriptions" element={<Navigate to="/" replace />} />
        <Route path="/privacy" element={<Privacy />}  />
        <Route path="/terms" element={<Terms />}  />
        <Route path="/disclaimer" element={<Disclaimer />}  />
        <Route path="/eula" element={<Eula />}  />
        <Route path="/finishSignIn" element={<FinishSignIn />} />
        <Route path="/finishSignIn/:login_token" element={<FinishSignIn />} />
        <Route path="/:resourceType" element={<PartnerResourcesMobile resourceType={searchFilterOptions.currentFilter.resourceType} searchFilterOptions={searchFilterOptions} />}  />
        <Route path="/communities" element={<PartnerCommunitiesMobile />}  />
        <Route path="*" element={<PartnerResourcesMobile resourceType="kitchen" searchFilterOptions={searchFilterOptions} />}  />
    </Routes>
  )
}



export default UnAuthView;